import { useSettingsStore, useUserStore } from '../store';

// Тестер платежных фич: username из settings.paymentTesters.
// Для тестеров Steam-пополнение работает при выключенном флаге,
// а в корзине показывается выбор способа оплаты (СБП/Crypto).
export const usePaymentTester = (): boolean => {
  const settings = useSettingsStore((s) => s.settings);
  const user = useUserStore((s) => s.user);
  const uname = (user?.username || '').replace(/^@/, '').toLowerCase();
  return !!uname && !!settings.paymentTesters?.includes(uname);
};
